import { mergeStyleSets } from "@uifabric/merge-styles";

export interface PoemPageClassNames {
    date: string;
    root: string;
}

export function getClassNames(): PoemPageClassNames {
    return mergeStyleSets({
        date: {
            fontSize: "11px"
        },
        root: {
            display: "flex",
            "justify-content": "center",
            marginTop: 50
        }
    });
}
